import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';

const Butterfly = ({doneLoading}) => {
  useEffect(() => {
    if (doneLoading && typeof window !== 'undefined') {
      const existingScript = document.getElementById('butterflyScript');
      if (!existingScript) {
        const script = document.createElement('script');
        script.src = 'https://butterfly-button.web.app/cdn/butterfly-plugin.js';
        script.defer = true;
        script.id = 'butterflyScript';
        document.head.appendChild(script);
        script.onload = () => {
          console.debug('butterfly script loaded');
        };
      }
    }
  }, [doneLoading]);

  if (!doneLoading) return null; //also add NODE_ENV case

  return (
    <Image key={'buterfly_img'}
      onClick={() => {
        if (typeof window !== 'undefined')
          window.bf_ReporterPlugin.toggleButterflyReporter('e8840d56-9b93-4c8e-a19d-c1e1aa0c4c97', 'IL', 'he');
      }}
      src={'https://butterfly-button.web.app/img/butterfly-logo-200.png'}
      style={{width: '30px', position: 'fixed', top: '210px', left: 0, zIndex: 10000}}
      alt={'The Butterfly Button'} />
  );
};

export default Butterfly;
